"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "valli-del-pasubio": {
    "5f694663": [{
      "hkey": "da597c65",
      "slug": "valli-del-pasubio",
      "name": "Valli del Pasubio",
      "primary": true,
      "skipSearch": false
    }],
    "collo": [{
      "hkey": "da597c65",
      "slug": "valli-del-pasubio",
      "name": "Valli del Pasubio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "f7ede0bd": [{
      "hkey": "da597c65",
      "slug": "valli-del-pasubio",
      "name": "Valli del Pasubio",
      "primary": true,
      "skipSearch": false
    }],
    "malunga": [{
      "hkey": "da597c65",
      "slug": "valli-del-pasubio",
      "name": "Valli del Pasubio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "2eb290ce": [{
      "hkey": "da597c65",
      "slug": "valli-del-pasubio",
      "name": "Valli del Pasubio",
      "primary": true,
      "skipSearch": false
    }],
    "nuovo": [{
      "hkey": "da597c65",
      "slug": "valli-del-pasubio",
      "name": "Valli del Pasubio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "553305a4": [{
      "hkey": "da597c65",
      "slug": "valli-del-pasubio",
      "name": "Valli del Pasubio",
      "primary": true,
      "skipSearch": false
    }],
    "savena-savenella": [{
      "hkey": "da597c65",
      "slug": "valli-del-pasubio",
      "name": "Valli del Pasubio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "90d0fd16": [{
      "hkey": "da597c65",
      "slug": "valli-del-pasubio",
      "name": "Valli del Pasubio",
      "primary": true,
      "skipSearch": false
    }],
    "val-maso": [{
      "hkey": "da597c65",
      "slug": "valli-del-pasubio",
      "name": "Valli del Pasubio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "f300f02b": [{
      "hkey": "da597c65",
      "slug": "valli-del-pasubio",
      "name": "Valli del Pasubio",
      "primary": true,
      "skipSearch": false
    }],
    "zavino": [{
      "hkey": "da597c65",
      "slug": "valli-del-pasubio",
      "name": "Valli del Pasubio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;